/* eslint-disable max-len */
import React from "react";
import { Col, Row, Image } from "antd";
import { dashboardStrings } from "config/site.string";
import { LogoIcon } from "config/IconConfig";
import { BASE_COLORS, FONT_SIZE_PX } from "config/theme/constants";
import { ProfileDropdown } from "components/header/ProfileDropdown";
import * as S from "../styles";

interface DesktopHeaderProps {
  isTwoColumnsLayout: boolean;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({
  isTwoColumnsLayout,
}) => {
  return (
    <>
      <Row justify="space-between" align="middle">
        <Col xl={18} xxl={18} md={16} sm={16}>
          <Row justify="space-between" gutter={24}>
            <Col span={4}>
              <div style={{ width: 115 }}>
                <Image src={LogoIcon} preview={false} alt="logo" />
              </div>
            </Col>
            <Col
              span={20}
              style={{
                textAlign: "center",
                letterSpacing: 0,
                color: BASE_COLORS.downRiver,
                fontSize: FONT_SIZE_PX.FONT23,
                opacity: 1,
                marginTop: 10,
              }}
            >
              {dashboardStrings?.orderEntryPortal}
            </Col>
          </Row>
        </Col>
        <S.ProfileColumn
          xl={6}
          xxl={6}
          md={8}
          sm={8}
          $isTwoColumnsLayout={isTwoColumnsLayout}
        >
          <Row align="middle" justify="end" gutter={[10, 10]}>
            <Col className="profile-menu-container">
              <ProfileDropdown />
            </Col>
          </Row>
        </S.ProfileColumn>
      </Row>
    </>
  );
};
